import {
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  background-color: ${base_colorRaisedSurface};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;

  .ContentCard {
    box-shadow: none;
  }

  &.has-top-alert-panel {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .AlertPanel.warning {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .font-bold {
      ${font_md};
      color: ${text_colorTextPrimary};
    }

    .font-regular {
      ${font_md}
    }
  }

  .OrgVirtualCardsEnablePanel-bottom {
    padding: ${spacing(4)} ${spacing(10)} ${spacing(4)};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: ${base_colorSurfaceSecondary};

    .connect-text {
      ${font_md}
    }

    .linktext-content {
      display: inline-block;
    }
  }
`
